import { CommunicationDataType } from '@toilet-paper-games/core';
import { NetworkDataType } from './models/NetworkDataTransfers';

export const DEV_GAME_ID = 'dev';

export const ignoredCommunicationDataDebugMessageTypes = [
  CommunicationDataType.PING_HOSTER,
  CommunicationDataType.PONG_CONTROLLER,
  CommunicationDataType.PONG_HOSTER,
];

export const ignoredNetworkDataDebugMessageTypes = [
  NetworkDataType.PING_H2C,
  NetworkDataType.PONG_C2H,
  NetworkDataType.PONG_H2C,
];
